import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { Services } from './Services.js';
import { servicesProviderCoveragePlatformDataSchema } from './ServicesProviderCoveragePlatformData.js';

class ServicesProviderCoveragePlatform extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderCoveragePlatformDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderCoveragePlatform.validation', `ServicesProviderCoveragePlatform data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.COVERAGE_PLATFORM,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.COVERAGE_PLATFORM, ServicesProviderCoveragePlatform);

export { ServicesProviderCoveragePlatform };
//# sourceMappingURL=ServicesProviderCoveragePlatform.js.map
